import { app } from './Api';

export const getTechnicianMapSnapshot = async () => {
    return app.get('technician_map/snapshot');
};

export const getTechnicianMapTrack = async (driverId, date) => {
    const params = { driver_id: driverId };
    if (date) {
        params.date = date;
    }
    return app.get('technician_map/track', { params, timeout: 20000 });
};

export const getTechnicianDayReport = async (driverId, date) => {
    const params = { driver_id: driverId };
    if (date) {
        params.date = date;
    }
    return app.get('technician_map/day_report', { params, timeout: 45000 });
};

export const downloadTechnicianDayPdf = async (driverId, date) => {
    const params = { driver_id: driverId };
    if (date) {
        params.date = date;
    }
    const response = await app.get('technician_map/day_report/pdf', {
        params,
        responseType: 'blob',
        timeout: 90000
    });
    return response.data;
};
